import { useContext } from "react";
import { LayoutContext } from "./LayoutContext";

export function useLayoutFragment<T>(render: (ctx: NonNullable<React.ContextType<typeof LayoutContext>>) => T): T | null {
  const ctx = useContext(LayoutContext);
  return ctx ? render(ctx) : null;
}
